import { useState, useEffect } from 'react'

function RSVPCards(props) {
    const [rsvpUpdates, setRsvpUpdates] = useState([])
    const [pageLoading, setPageLoading] = useState(true);
    const [loadingError, setLoadingError] = useState(false);

    useEffect(() => {
        fetchData();
    }, []);

    async function fetchData() {
        try {
            const res = await fetch(
                `https://wedding-website-backend-nu.vercel.app/api/changes`
            );

            if (!res.ok) {
                throw new Error(`HTTP error! status: ${res.status}`);
            }

            const data = await res.json();
            setRsvpUpdates(data.changes);
        } catch (err) {
            console.error(err);
            setLoadingError(true);
        } finally {
            setPageLoading(false);
        }
    }

    const renderResponse = (bool) => {
        if (bool === true) return "Yes";
        if (bool === false) return "No";
        return bool;
    }

    function renderRSVPCard(rsvp) {
        const date = new Date(rsvp.created_at);
        const options = {
            timeZone: "America/New_York",
            year: "numeric",
            month: "long",
            day: "numeric",
            hour: "numeric",
            minute: "numeric",
            second: "numeric",
        };
        const estDateStr = date.toLocaleString("en-US", options);

        const renderGuest = (guest) => (
            <li key={guest.name ?? Math.random()} className="p-2 border-b">
                <div className="subheading text-black">{guest.name.toUpperCase()}</div>
                <div className="text-sm text-customGray mt-1">
                    <div>Attending Welcome Party: <span className={renderResponse(guest.attend_welcome_party) === "No" ? "text-red-400" : ""}>{String(renderResponse(guest.attend_welcome_party))}</span></div>
                    <div>Attending Wedding: <span className={renderResponse(guest.attend_wedding) === "No" ? "text-red-400" : ""}>{String(renderResponse(guest.attend_wedding))}</span></div>
                    <div>Wedding Entree: <span className={guest.wedding_entree ? "" : "text-red-400"}>{String(guest.wedding_entree)}</span></div>
                    <div>Dietary Restrictions: <span className={guest.dietary_restrictions ? "text-red-400" : ""}>{String(guest.dietary_restrictions)}</span></div>
                </div>
            </li>
        );

        return (
            <div
                key={rsvp._id}
                className="bg-white shadow-md rounded-lg p-6 mb-6 border border-gray-200"
            >
                <div className="text-xs text-gray-500 mb-2">{estDateStr}</div>
                <ul className="space-y-2">{rsvp.guests.map(renderGuest)}</ul>
                <div className="mb-4"></div>
                <div className="font-medium mb-1">Email: {String(rsvp.email)}</div>
                <div className="font-medium mb-1">Phone: {String(rsvp.phone)}</div>
                <div className="mb-4">
                    <span className="font-semibold">Comments: </span>
                    <span className={rsvp.comments ? "text-red-400" : ""}>{rsvp.comments || ""}</span>
                </div>
            </div>
        );
    }

    let allConfrimedRSVPs = [];

    rsvpUpdates.forEach(rsvp => {
        // Check if at least one guest is attending
        const hasAttendingGuest = rsvp.guests.some(
            guest => guest.attend_wedding === true
        );

        if (!hasAttendingGuest) return;

        // Avoid duplicates by id
        const exists = allConfrimedRSVPs.some(item => item.id === rsvp.id);

        if (!exists) {
            allConfrimedRSVPs.push(rsvp);
        }
    });

    return (
        <div className="mt-10 p-4 bg-blush min-h-96 rounded-md">
            <div className="subheading text-rose mb-6 text-2xl">Confirmed Groups</div>
            {pageLoading && <p>Loading...</p>}
            {loadingError && <p className="text-red-400">Failed to fetch RSVPs</p>}
            {!pageLoading && !loadingError && (
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 text-sm">
                    {allConfrimedRSVPs.map(renderRSVPCard)}
                </div>
            )}
        </div>
    )
}

export default RSVPCards 
